import { InjectionToken } from '@angular/core';

export const DIALOG_CLOSE = new InjectionToken<() => void>('DIALOG_CLOSE');
